import {
  GET_AUDIENCE_BUILDERS_REQUEST,
  GET_COMPANIES_REQUEST,
  GET_FUSIONS_REQUEST,
  GET_MY_COMPANY_REQUEST,
  GET_USERS_BY_COMPANY_REQUEST,
  GET_USERS_REQUEST,
  IGNORE_TWITTER_TOKEN_REQUEST,
  GENERATE_TWITTER_URL_REQUEST,
} from '../constants/action-types';

export const requestFusions = () => ({
  type: GET_FUSIONS_REQUEST,
});

export const requestAudienceBuilders = () => ({
  type: GET_AUDIENCE_BUILDERS_REQUEST,
});

export const requestCompanies = query => ({
  type: GET_COMPANIES_REQUEST,
  query,
});

export const requestUsers = query => ({
  type: GET_USERS_REQUEST,
  query,
});

export const requestUsersByCompany = (id, query) => ({
  type: GET_USERS_BY_COMPANY_REQUEST,
  id,
  query,
});

export const requestMyCompany = () => ({
  type: GET_MY_COMPANY_REQUEST,
});

export const requestIgnoreTwitterToken = () => ({
  type: IGNORE_TWITTER_TOKEN_REQUEST,
});

export const requestGenerateTwitterUrl = () => ({
  type: GENERATE_TWITTER_URL_REQUEST,
});
